export interface EcommerceEvent {
  event: string;
  step?: string;
  premium_calculator?: string;
  ecommerce: {
    currency?: string;
    value?: number;
    transaction_id?: string;
    shipping_tier?: string;
    items: Item[];
  };
}

export interface Item {
  item_id?: string;
  item_name: string;
  item_category: string;
  item_category2?: string;
  item_category3: string;
  item_category4?: string;
  item_category5?: string;
  item_brand?: string;
  price: number;
  quantity: number;
  item_variant?: string;
  contract_length?: string;
}

export const ECOMMERCE_EVENT_TYPES = {
  VIEW_ITEM_LIST: 'view_item_list',
  SELECT_ITEM: 'select_item',
  VIEW_ITEM: 'view_item',
  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  VIEW_CART: 'view_cart',
  BEGIN_CHECKOUT: 'begin_checkout',
  ADD_SHIPPING_INFO: 'add_shipping_info',
};
